const minute = 60 * 1000;
const hour = 60 * minute;

export const SWR_CONFIG = {
	dedupingInterval: 2 * minute,
	refreshInterval: hour,
	revalidateOnFocus: false
};
